




































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { DateTimeSpan, ScheduleType } from "@/store/modules/enums";
import { filterOn } from "@/utils";
import PatientGapsPopover from "@/components/schedule/Gaps.vue";
import GapEditor from "@/components/gap/GapEditor.vue";
import SelectPopover from "@/components/SelectPopover.vue";
import DateRangePopover from "@/components/DateRangePopover.vue";
import PatientFilterPopover from "@/components/PatientFilterPopover.vue";
import InputPopover from "@/components/InputPopover.vue";
import { ScheduleDateFilter } from "@/store/modules/types";
import { getDate } from '@/services/timezone';

@Component({
  components: {
    PatientGapsPopover,
    GapEditor,
    SelectPopover,
    DateRangePopover,
    PatientFilterPopover,
    InputPopover,

  },
  computed: mapState("schedule", ["list", "calendars", "priorities", "status", "reasons"]),
})
export default class ListView extends Vue {
  list!: any;
  lastShownPatientGaps!: any;
  selectedGap: any = null;
  getDate = getDate;
  patientGapsPopover = {
    appt: null,
    show: false,
  };
  language: any = [{
    id: "EN",
    name: "English"
  }, {
    id: "ES",
    name: "Spanish"
  }];

  types: any = [{
    id: "APT",
    name: "REGULAR"
  }, {
    id: "SRV",
    name: "SERVICE"
  }, {
    id: "DLV",
    name: "DELIVERY"
  }, {
    id: "RRS",
    name: "READY RESPONDERS"
  }, {
    id: "RMD",
    name: "REMINDER"
  }];

  origins: any = [{
    id: "ONLINE",
    name: "ONLINE"
  }, {
    id: "CALLR",
    name: "CAROLINA AI"
  }, {
    id: "WMPC",
    name: "PATIENTCARE"
  }, {
    id: "WAITINGMED",
    name: "LEGACY"
  }, {
    id: "KIOSK",
    name: "KIOSK"
  }, {
    id: "WMAPI",
    name: "EMR VENDOR/API"
  }, {
    id: "OTHERS",
    name: "OTHERS"
  }];

  showHidePatientGaps(appt: any) {
    this.patientGapsPopover.appt = appt;
    this.patientGapsPopover.show = !this.patientGapsPopover.show;
  }
  get patientFilterOn() {
    return filterOn(this.list.filter.patient);
  }
  setPatientFilter(value: any) {
    this.$store.commit("schedule/SET_PATIENT_FILTER", value);
  }
  setDateFilter(timeSpan: DateTimeSpan, from: string, to: string) {
    //x=2;

    //console.log(getDate(this.$moment()).format());
    /* if (!from && !to) {
       from = this.$moment().toDate().toString();
       to = this.$moment().toDate().toString();
     }else if (this.$moment(from) > this.$moment(to)) {
       to = from;
     }*/

    console.log(timeSpan + ',' + from + ',' + to)
    this.$store.commit("schedule/SET_DATE_FILTER", { timeSpan, from, to });
  }
  setCalendarFilter(value: number[]) {
    this.$store.commit("schedule/SET_CALENDAR_FILTER", value);
  }
  setPriorityFilter(value: number[]) {
    this.$store.commit("schedule/SET_PRIORITY_FILTER", value);
  }
  setReasonFilter(value: number[]) {
    this.$store.commit("schedule/SET_REASON_FILTER", value);
  }
  setStatusFilter(value: number[]) {
    this.$store.commit("schedule/SET_STATUS_FILTER", value);
  }
  setCreatedFilter(timeSpan: DateTimeSpan, from: string, to: string) {
    this.$store.commit("schedule/SET_CREATED_FILTER", { timeSpan, from, to });
  }
  setLangFilter(value: string[]) {
    this.$store.commit("schedule/SET_LANG_FILTER", value);
  }
  setTypeFilter(value: string[]) {
    this.$store.commit("schedule/SET_TYPE_FILTER", value);
  }
  setOriginFilter(value: string[]) {
    this.$store.commit("schedule/SET_ORIGIN_FILTER", value);
  }
    setMultiApptIdFilter(value: string) {
    this.$store.commit("schedule/SET_MULTI_APPT_ID_FILTER", value);
  }
  dateFilterOn(filter: ScheduleDateFilter): boolean {
    return filter.timeSpan || filter.from || filter.to;
  }
  orderBy(field: string) {
    this.$store.commit("schedule/SET_ORDER_BY_FILTER", field);
  }
  apptTypeIcon(type: ScheduleType) {
    switch (type) {
      case ScheduleType.REGULAR:
        return "far fa-calendar-alt";
      case ScheduleType.SERVICE:
        return "fas fa-stethoscope";
      case ScheduleType.DELIVERY:
        return "fas fa-truck";
      case ScheduleType.READY_RESPONDERS:
        return "fas fa-user-md";
      case ScheduleType.REMINDER:
        return "far fa-bell"
    }
  }
  apptTypeName(type: ScheduleType) {
    switch (type) {
      case ScheduleType.REGULAR:
        return "REGULAR APPPOINTMENT";
      case ScheduleType.SERVICE:
        return "SERVICE APPPOINTMENT";
      case ScheduleType.DELIVERY:
        return "DELIVERY APPPOINTMENT";
      case ScheduleType.READY_RESPONDERS:
        return "READY RESPONDERS APPOINTMENT";
      case ScheduleType.REMINDER:
        return "REMINDER APPPOINTMENT"
    }
  }
  reminderIcon(appt: any) {
    const count = appt.reminderCount;
    if (count) {
      if (count <= 2) {
        return "fas fa-bell text-success";
      } else if (count <= 4) {
        return "fas fa-bell text-warning";
      } else {
        return "fas fa-bell text-danger";
      }
    } else {
      return "far fa-bell";
    }
  }
  editGap(gap: any) {
    this.selectedGap = gap;
    this.$modal.show("gap-editor");
  }
  async setApptStatus(status: any, appt: any) {
    try {
      appt.statusName = status.name;
      appt.statusBackColor = status.backColor || "white";
      appt.statusFontColor = status.fontColor || "black";
      await this.$store.dispatch("schedule/saveStatus", {
        id: appt.id,
        statusId: status.id,
      });
      this.$bvToast.toast(`Appointment #${appt.id} has been updated.`, {
        title: "WaitingMed",
        toaster: "b-toaster-top-right",
        autoHideDelay: 3000,
        solid: true,
      });
    } catch (error) {
      console.log(error);
    }
  }

  async changeApptLang(appt: any) {
    try {
      appt.lang = appt.lang === "EN" ? "ES" : "EN";

      await this.$store.dispatch("schedule/changeLang", {
        id: appt.id
      });
      this.$bvToast.toast(`Appointment #${appt.id} has been updated.`, {
        title: "WaitingMed",
        toaster: "b-toaster-top-right",
        autoHideDelay: 3000,
        solid: true,
      });
    } catch (error) {
      console.log(error);
    }
  }
  getOriginTitle(appt) {
    if (appt.isRequest) return 'ONLINE REQUEST';
    switch (appt.origin) {
      case 'CALLR':
        return 'CAROLINA AI';
      case 'WMAPI':
        return 'EMR VENDOR/API';
      case 'KIOSK':
        return 'KIOSK';
      case 'ONLINE':
        return 'ONLINE APPOINTMENT';
      default:
        return '';
    }
  }

  getOriginIconClass(appt) {
    const base = ['fas', 'fa-fw'];
    if (appt.isRequest) return [...base, 'fa-globe-americas', 'text-danger'];
    switch (appt.origin) {
      case 'CALLR':
        return [...base, 'fa-robot', 'ai-fc'];
      case 'WMAPI':
        return [...base, 'fa-hospital-alt', 'wm-fc-2'];
      case 'KIOSK':
        return [...base, 'fa-desktop', 'wm-fc-2'];
      default:
        return [...base, 'fa-globe-americas', 'wm-fc-2'];
    }
  }

  copyToClipboard(text) {

    navigator.clipboard
        .writeText(text)
        .then(() => {

            console.log(
                "Copied!"
            );

        })
        .catch(error => {

            console.error(
                "Copy failed",
                error
            );

        });
}
  mounted() { }
}
